export class User {
    userid: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    email: string | undefined;

    constructor(userid: string, firstname: string, lastname: string, email: string) {
        this.userid = userid;
        this.firstname = firstname;
        this.lastname = lastname;
        this.email = email;

        if (this.email) {
            this.email = this.email.toLowerCase();
        }
    }

    public get fullName() {
        const first = this.firstname ?? '';
        const last = this.lastname ?? '';
        return `${first} ${last}`;
    }
}
